import { useMemo } from "react";

import {
  getDepartmentIdByStore,
  getHeaderLabel,
  getStoreLevelAccountName,
} from "../../../pages/LandingPage/helpers";

import { SetupBaseRequestInfo } from "../../../types/types.api";
import {
  IAMUserState,
  LandingPageOptions,
  SetupListNavInfoByDepartment,
  UserData,
} from "../../../types";
import { EffectiveUserContext } from "../launch/resolveLaunchContext";

interface UseUserSetupInfoParams {
  user: UserData;
  selected: LandingPageOptions;
  iamUserState: IAMUserState;
  setupListNavInfoByDepartment: SetupListNavInfoByDepartment;
  resolvedLaunchContext: EffectiveUserContext;
}

export const useUserSetupInfo = ({
  user,
  selected,
  iamUserState,
  setupListNavInfoByDepartment,
  resolvedLaunchContext,
}: UseUserSetupInfoParams) => {
  const fullName = `${user.user.firstName} ${user.user.lastName}`;

  const headerLabel = getHeaderLabel(selected);

  const { effectiveEnterpriseId, effectiveIamUserStoresCommaSeparated } =
    resolvedLaunchContext;

  const setupBaseRequestInfo: SetupBaseRequestInfo = useMemo(
    () => ({
      storeId: selected.store.value,
      enterpriseId: effectiveEnterpriseId,
      functionalArea: selected.department.value,
      functionalUnitName: selected.setup.value,

      departmentId: getDepartmentIdByStore({
        store: selected.store.value,
        department: selected.department.value,
        extendedAccountInfo: iamUserState.extendedAccountInfo,
        setupListNavInfoByDepartment,
      }),

      accountName: getStoreLevelAccountName(
        selected.store.value,
        selected.department.value,
        iamUserState.extendedAccountInfo,
        setupListNavInfoByDepartment,
      ),

      groupId: selected.groupId.value,

      stores: effectiveIamUserStoresCommaSeparated,
    }),
    [
      selected,
      effectiveEnterpriseId,
      effectiveIamUserStoresCommaSeparated,
      iamUserState.extendedAccountInfo,
      setupListNavInfoByDepartment,
    ],
  );

  return {
    fullName,
    headerLabel,
    setupBaseRequestInfo,
  };
};
